import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Account } from 'app/shared/models/account';
import { Library, OPTIONS } from '../library';
import { Holidays } from 'app/shared/models/holidays';
import { Devices } from 'app/shared/models/devices';
import { DevicesCount } from 'app/shared/models/devicesCount';
import { EmployeeRelation } from 'app/shared/models/employee-relation';
import { EmployeeSchedule } from 'app/shared/models/employeeSchedule';
import { DashboardContent } from 'app/shared/models/dashboardContent';
import { HRConcept } from 'app/shared/models/hr-concept';
import { Observable } from 'rxjs';
import { Time } from 'app/shared/models/time';
import { TimeEntries } from 'app/shared/models/timeEntries';
import { Password } from 'app/shared/models/password';
import { TokenMessage } from 'app/shared/models/token-message';
import { PayrollDefinition } from 'app/shared/models/payrollDef';
import { Schedule } from 'app/shared/models/schedule';
import { PayrollPeriod } from 'app/shared/models/payroll-period';
import { LeaveData } from 'app/shared/models/pendingLeave';
import { TimeSheetsData } from 'app/shared/models/timeSheetsData';
import { LeaveDataAll } from 'app/shared/models/pendingLeave copy';
import { AttendanceRecord } from 'app/shared/models/attendanceRecord';
import { EmployeeTimeSheet } from 'app/shared/models/employeeTimeSheet';
import { MonthPeriod } from 'app/shared/models/month-period';
import { TimeSheetLine } from 'app/shared/models/timeSheetLine';
import { PayrollLine } from 'app/shared/models/payrollLine';
import { PayrollSummary } from 'app/shared/models/payroll-summary';
import { PayrollDepartment } from 'app/shared/models/payroll-department';
import { PayrollType } from 'app/shared/models/payroll-type';
import { LeaveRecord } from 'app/admin-pages/leave-report/leave-report.component';

@Injectable({
  providedIn: 'root'
})
export class PrivateService {

  constructor(private http: HttpClient, private router: Router) { }

  getAccount() {
    return this.http.get<Account>(Library.API_ENDPOINT + 'account/info', OPTIONS);
  }

  getApiTime() {
    return this.http.get<Time>(Library.API_ENDPOINT + 'account/server_time', OPTIONS);
  }

  createTimeSheet(isCreated: boolean, displayName: string) {

    return this.http.post<boolean>(Library.API_ENDPOINT + `account/create_timesheet/${isCreated}/${displayName}`, OPTIONS);
  }

  getTimeSheet() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_timesheet', OPTIONS);
  }

  getTimeType() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_timeType', OPTIONS);
  }

  insertTime(
    time: Time,
    timeType: string,
    formData: FormData,
    deviceModel?: string,
    note?: string,
    clientID?: number,
    branchId?: number
  ) {
    const formattedTime = `${time.time},${time.date},${time.dateTime}`;

    const safeDeviceModel = deviceModel ?? null;
    const safeNote = note ?? null;
    const safeClientID = clientID ?? 0;
    const safeBranchId = branchId ?? 0;

    let params = new HttpParams()
      .set('deviceModel', safeDeviceModel)
      .set('note', safeNote)
      .set('clientID', safeClientID)
      .set('branchId', safeBranchId);

    return this.http.post<Time>(
      `${Library.API_ENDPOINT}account/insert_time/${formattedTime}/${timeType}`,
      formData,
      { params }
    );
  }

  insertFlexiTime(time: Time, timeType: string, formData: FormData, deviceModel: string, note: string, clientID: number, card: string, location: string, branchId?: number) {
    const formattedTime = `${time.time},${time.date},${time.dateTime}`;
    const params = new HttpParams()
      .set('deviceModel', deviceModel)
      .set('note', note)
      .set('clientID', clientID)
      .set('card', card)
      .set('location', location)
      .set('branchId', branchId ?? 0);
    return this.http.post<Time>(
      `${Library.API_ENDPOINT}account/insert_flexi_time/${formattedTime}/${timeType}`, formData,
      { params }
    );
  }

  getTimeEntries() {
    return this.http.get<TimeEntries>(Library.API_ENDPOINT + 'account/get_timeEntries', OPTIONS);
  }

  getFlexiTimeEntries() {
    return this.http.get<TimeEntries[]>(Library.API_ENDPOINT + 'account/get_flexiTimeEntries', OPTIONS);
  }

  changePassword(passwordForm: Password) {
    return this.http.post<TokenMessage>(Library.API_ENDPOINT + 'account/password/change', passwordForm, OPTIONS);
  }

  getSchedule() {
    return this.http.get<Schedule>(Library.API_ENDPOINT + 'account/employee_schedule', OPTIONS);
  }

  getPayrollDef() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_payrollDefinition', OPTIONS);
  }

  getHolidays() {
    return this.http.get<Holidays[]>(Library.API_ENDPOINT + 'account/get_holidays', OPTIONS);
  }

  submitTimeSheet(timeSheet_ID: string) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/submit_timeSheet/${timeSheet_ID}`, OPTIONS);
  }

  submitFlexiTimeSheet() {
    return this.http.post<any>(Library.API_ENDPOINT + `account/submit_flexi_timesheet`, OPTIONS);
  }

  getDevices() {
    return this.http.get<Devices[]>(Library.API_ENDPOINT + 'account/get_devices', OPTIONS);
  }

  getEmployeeDevices(employeeID: number) {
    return this.http.get<Devices[]>(Library.API_ENDPOINT + `account/get_employeeDevices/${employeeID}`, OPTIONS);
  }

  insertDevice(value: string, deviceName: string, password: string) {
    const body = { value, deviceName, password };
    return this.http.post<any>(Library.API_ENDPOINT + 'account/insert_device_user', body);
  }

  getDevicesCount() {
    return this.http.get<DevicesCount>(Library.API_ENDPOINT + 'account/get_devicesCount', OPTIONS);
  }

  deleteDevice(id: any) {
    return this.http.delete<any>(Library.API_ENDPOINT + `account/delete_device/${id}`, OPTIONS);
  }

  getEmployees(departmentID: any) {
    return this.http.get<EmployeeRelation>(Library.API_ENDPOINT + `account/get_employees/${departmentID}`, OPTIONS);
  }

  getEmployeesList(departmentID: any) {
    return this.http.get<EmployeeRelation[]>(Library.API_ENDPOINT + `account/get_employees/${departmentID}`, OPTIONS);
  }

  getEmployeesByBranch(branchID: any) {
    return this.http.get<EmployeeRelation>(Library.API_ENDPOINT + `account/get_employees_byBranch/${branchID}`, OPTIONS);
  }

  getEmployeesByBranchList(branchID: any) {
    return this.http.get<EmployeeRelation[]>(Library.API_ENDPOINT + `account/get_employees_byBranch/${branchID}`, OPTIONS);
  }

  getPayrollPeriod(id: any) {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_payrollPeriod/${id}`, OPTIONS);
  }

  getPayrollPeriodFilter(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payrollPeriod/${id}`, OPTIONS);
  }

  getPeriod() {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_period`, OPTIONS);
  }

  getPeriodWorkdays() {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_period_workdays`, OPTIONS);
  }

  getPeriodReimbursement() {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_period_reimbursement`, OPTIONS);
  }

  getPeriodLeave() {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_period_leave`, OPTIONS);
  }

  getPeriodBP(cBPartnerId: string): Observable<any[]> {
    return this.http.get<any[]>(
      Library.API_ENDPOINT + `account/get_period_bp/${cBPartnerId}`
    );
  }

  submitLeaveFormForEmployee(formData: any): Observable<any> {
    return this.http.post<any>(
      Library.API_ENDPOINT + `account/submit_employee_leave`,
      formData
    );
  }

  getHRConcept() {
    return this.http.get<HRConcept[]>(Library.API_ENDPOINT + `account/get_hr_concept`, OPTIONS);
  }

  getEmployeeSchedule(employeeID: any, payrollID: any) {
    return this.http.get<EmployeeSchedule[]>(Library.API_ENDPOINT + `account/get_employeeSchedule/${employeeID}/${payrollID}`, OPTIONS);
  }

  updateSchedule(schedule: EmployeeSchedule) {
    return this.http.post<any>(Library.API_ENDPOINT + 'account/update_schedule', schedule, OPTIONS);
  }

  insertSchedule(schedule: EmployeeSchedule, employeeID: number, payrollID: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_schedule/${employeeID}/${payrollID}`, schedule, OPTIONS);
  }

  getEmployeePDFs(employeeID: any, date: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/employee_pdfs/${employeeID}/${date}`, OPTIONS);
  }

  getUserIP() {
    return this.http.get<any>('https://jsonip.com', OPTIONS);
  }

  //Dashboard Endpoint
  getDashboardContent() {
    return this.http.get<DashboardContent>(Library.API_ENDPOINT + 'account/dashboard_data', OPTIONS);
  }

  getPayrollType() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_payrollType', OPTIONS);
  }

  generateBIR1601C(payrollID: number, periodID: number): Observable<HttpResponse<Blob>> {
    const url = `${Library.API_ENDPOINT}common/generate_bir_1601c/${payrollID}/${periodID}`;

    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  getBranches() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_branches', OPTIONS);
  }

  getBranchAll() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_branches_all', OPTIONS);
  }

  getCountries() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_countries', OPTIONS);
  }

  getAddressDetails() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_address', OPTIONS);
  }

  getHRPeriod(id: any) {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_hrPeriodID/${id}`, OPTIONS);
  }

  getPeriodOnDepartment(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payrollPeriod_on_department/${id}`, OPTIONS);
  }

  getPayrollPeriodImportTimesheet() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_period_import_timesheet`, OPTIONS);
  }

  getTimeSheetData(id: any, payrollID: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/timeSheet_data/${id}/${payrollID}`, OPTIONS);
  }

  getActualOT() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_actualOT', OPTIONS);
  }

  getAllowedOTMinutes() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_AllowedOTMinutes', OPTIONS);
  }

  getActualOTPersonal() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_actualOT_personal', OPTIONS);
  }

  getAllowedOTMinutesPersonal() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_AllowedOTMinutes_personal', OPTIONS);
  }

  getAllLates() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_allLates', OPTIONS);
  }

  getLatesPersonal() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_lates_personal', OPTIONS);
  }

  getAllCost() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_allCost', OPTIONS);
  }

  getAllAbsents() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_allAbsents', OPTIONS);
  }

  submitLeaveForm(formData: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + 'account/submit_leave', formData, OPTIONS);
  }

  getPendingLeaves() {
    return this.http.get<LeaveData[]>(Library.API_ENDPOINT + 'account/get_pending_leaves', OPTIONS);
  }

  getApprovedLeaves() {
    return this.http.get<LeaveData[]>(Library.API_ENDPOINT + 'account/get_approved_leaves', OPTIONS);
  }

  getEmployeeLeaves(userId: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_leaves_per_user/${userId}`, OPTIONS);
  }

  getTimeSheets() {
    return this.http.get<TimeSheetsData[]>(Library.API_ENDPOINT + `account/get_timesheets_admin`, OPTIONS);
  }

  getPendingLeavesAll() {
    return this.http.get<LeaveDataAll[]>(Library.API_ENDPOINT + 'account/get_pending_leaves_all', OPTIONS);
  }

  approveLeave(id: string) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/approve_leave/${id}`, OPTIONS);
  }

  declineLeave(id: string) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/decline_leave/${id}`, OPTIONS);
  }

  getTodayAbsent() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_today_absent', OPTIONS);
  }

  getTodayLate() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_today_late', OPTIONS);
  }

  getTodayPresent() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_today_present', OPTIONS);
  }

  getRestDay() {
    return this.http.get<any>(Library.API_ENDPOINT + 'continuous/is_restDay_count', OPTIONS);
  }

  getEmployeeAttendance() {
    return this.http.get<AttendanceRecord[]>(Library.API_ENDPOINT + 'account/get_employee_attendance', OPTIONS);
  }

  getEmployeeTimeSheet(id: any) {
    return this.http.get<EmployeeTimeSheet[]>(Library.API_ENDPOINT + `account/get_employee_timesheet/${id}`, OPTIONS);
  }

  getMonthPeriod(id: any) {
    return this.http.get<MonthPeriod[]>(Library.API_ENDPOINT + `account/get_monthPeriod/${id}`, OPTIONS);
  }

  getMonthPeriodPersonal(id: any) {
    return this.http.get<MonthPeriod[]>(Library.API_ENDPOINT + `account/get_monthPeriod_personal`, OPTIONS);
  }

  getTimeSheetValue(employeeID: any, payrollID: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheet_value/${employeeID}/${payrollID}`, OPTIONS);
  }

  getTimeSheetValues() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheet_value`, OPTIONS);
  }

  getTimeSheetValueSearch(searchForm: any) {
    return this.http.post<any[]>(Library.API_ENDPOINT + `account/get_timesheet_value_search`, searchForm, OPTIONS);
  }

  getTimeSheetPersonal() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheet_value_personal`, OPTIONS);
  }

  getTimeSheetLineValue(employeeID: any, payrollID: any) {
    return this.http.get<TimeSheetLine[]>(Library.API_ENDPOINT + `account/get_timesheetline_value/${employeeID}/${payrollID}`, OPTIONS);
  }

  getComputations() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `common/get_computations`, OPTIONS);
  }

  getTimeSheetLineMinutes(id: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheetline_minutes/${id}`, OPTIONS);
  }

  getTimeSheetLineSchedules(id: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheetline_schedules/${id}`, OPTIONS);
  }

  getTimeSheetLineOther(id: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheetline_other/${id}`, OPTIONS);
  }

  getTimeSheetValuePersonal(payrollID: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_timesheet_value_personal/${payrollID}`, OPTIONS);
  }

  getTimeSheetLineValuePersonal(payrollID: any) {
    return this.http.get<TimeSheetLine[]>(Library.API_ENDPOINT + `account/get_timesheetline_value_personal/${payrollID}`, OPTIONS);
  }

  getPayrollValue(employeeID: any, payrollID: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_payroll_value/${employeeID}/${payrollID}`, OPTIONS);
  }

  getPayrollValuePersonal(payrollID: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_payroll_value_personal/${payrollID}`, OPTIONS);
  }

  getPayrollLineValue(employeeID: any, payrollID: any) {
    return this.http.get<PayrollLine[]>(Library.API_ENDPOINT + `account/get_payroll_line_value/${employeeID}/${payrollID}`, OPTIONS);
  }

  getPayrollLineValuePersonal(payrollID: any) {
    return this.http.get<PayrollLine[]>(Library.API_ENDPOINT + `account/get_payroll_line_value_personal/${payrollID}`, OPTIONS);
  }

  allowPayslip(allowPayslip: boolean, id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/allow_payslip/${allowPayslip}/${id}`, OPTIONS);
  }

  autoSubmitTimeEntries(autoSubmit: boolean) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/auto_submit_time_entries/${autoSubmit}`, OPTIONS);
  }

  getPayrollSummary(departmentID: any, payrollID: any) {
    return this.http.get<PayrollSummary[]>(Library.API_ENDPOINT + `account/get_payroll_summary/${departmentID}/${payrollID}`, OPTIONS);
  }

  getDepartment() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_department`, OPTIONS);
  }

  getDepartments() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_department`, OPTIONS);
  }

  getDepartmentsAll() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_department_all`, OPTIONS);
  }

  getBranchesRelation() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_branch`, OPTIONS);
  }

  getBranchesAll() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_branch_all`, OPTIONS);
  }

  getHR_Payroll(id: any) {
    return this.http.get<PayrollType>(Library.API_ENDPOINT + `account/get_payrollType/${id}`, OPTIONS);
  }

  getPayrollPeriodDepartmentAll(id: any) {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_payrollPeriod_department/${id}`, OPTIONS);
  }

  getPayrollPeriods() {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_payrollPeriods`, OPTIONS);
  }

  getTimeSheetSummary(departmentID: any, payrollID: any) {
    return this.http.get<TimeSheetLine[]>(Library.API_ENDPOINT + `account/get_timesheet_summary/${departmentID}/${payrollID}`, OPTIONS);
  }

  getTimeEntriesSummary(departmentID: any, payrollID: any) {
    return this.http.get<TimeSheetLine[]>(Library.API_ENDPOINT + `account/get_timeentries_summary/${departmentID}/${payrollID}`, OPTIONS);
  }

  getTimeEntriesSummaryRevised(filters: { payrollID?: number, periodID?: string, startDate?: string, endDate?: string } = {}) {
    const body: any = {
      start_date: filters.startDate ?? null,
      end_date: filters.endDate ?? null
    };

    // Only include optional fields if they have values
    if (filters.payrollID) body.payroll_id = filters.payrollID;
    if (filters.periodID) body.period_id = filters.periodID;

    return this.http.post<any[]>(
      Library.API_ENDPOINT + 'account/get_timeentries_summary_revised',
      body,                        // ✅ clean JSON body, no headers here
      { headers: OPTIONS.headers } // ✅ headers go in config only
    );
  }

  insertLoan(loanForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'account/insert_loan', loanForm, OPTIONS);
  }

  getAllowableLoanAmt() {
    return this.http.get<number>(Library.API_ENDPOINT + `account/get_allowable_loan_amt`, OPTIONS);
  }

  getLoans() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_loans`, OPTIONS);
  }

  getEmployeeLoans(employeeID: number) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_active_loan/${employeeID}`, OPTIONS);
  }

  getPendingLoans() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_pending_loan_all`, OPTIONS);
  }

  getLoanLines(id: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_loan_lines/${id}`, OPTIONS);
  }

  getLoanAmounts() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_loan_amounts`, OPTIONS);
  }

  insertPaidLoan(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_paid_loan/${id}`, OPTIONS);
  }

  getPendingReimbursementInfo() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/pending_reimbursement_info', OPTIONS);
  }

  getApprovedReimbursementInfo() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/approved_reimbursement_info', OPTIONS);
  }

  getRejectedReimbursementInfo() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/rejected_reimbursement_info', OPTIONS);
  }

  getReimbursementLines(id: number) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/reimbursements_lines/${id}`, OPTIONS);
  }

  approveReimbursement(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/approve_reimbursement/${id}`, OPTIONS);
  }

  getReimbursementCount() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/reimbursement_count', OPTIONS);
  }

  declineReimbursement(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/decline_reimbursement/${id}`, OPTIONS);
  }

  getPayrollPeriodLeave(id: any) {
    return this.http.get<PayrollPeriod[]>(Library.API_ENDPOINT + `account/get_payrollPeriod_leave/${id}`, OPTIONS);
  }

  insertReimbursement(formData: any): Observable<any> {
    // Convert formData to a single query parameter
    const jsonFormData = JSON.stringify(formData);

    // Construct HttpParams to include formData and fileNames as query parameters
    let params = new HttpParams().set('formData', jsonFormData);

    // Make HTTP POST request
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_fund_reimbursement`, formData, OPTIONS);
  }

  insertReimbursementItems(formDataFiles: FormData, fileName: string, expenseID: number, employeeID: number): Observable<any> {

    let params = new HttpParams().set('filename', fileName);

    // Make HTTP POST request
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_fund_reimbursement_items/${expenseID}/${employeeID}`, formDataFiles, { params });
  }

  getPendingReimbursementInfoIndividual() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/pending_reimbursement_info_individual', OPTIONS);
  }

  getApprovedReimbursementInfoIndividual() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/approved_reimbursement_info_individual', OPTIONS);
  }

  getRejectedReimbursementInfoIndividual() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/rejected_reimbursement_info_individual', OPTIONS);
  }

  deleteSchedule(id: any) {
    return this.http.delete<any>(Library.API_ENDPOINT + `account/delete_schedule/${id}`, OPTIONS);
  }

  getInvalidTimesheets(periodID: any) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_invalid_timesheets/${periodID}`, OPTIONS);
  }

  getClients() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/get_clients', OPTIONS);
  }

  getClientAndNoteInfo() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/getClientAndNote_info', OPTIONS);
  }

  getPayrollConcept(C_BPartner_ID: number) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_concept/${C_BPartner_ID}`, OPTIONS);
  }

  getSalaryScale() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_salary_scale`, OPTIONS);
  }

  insertEmployeeDetails(employeeDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_employee_details`, employeeDetails, OPTIONS);
  }

  insertEmployeeDetailsFromCSV(employeeDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_employee_details_csv`, employeeDetails, OPTIONS);
  }

  getPayrollJob(HR_Department_ID: number) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_payroll_job/${HR_Department_ID}`, OPTIONS);
  }

  insertEmployeeAttribute(employeeRates: any, C_BPartner_ID: number): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_employee_attribute/${C_BPartner_ID}`, employeeRates, OPTIONS);
  }

  insertEmployeeSchedule(employeeSchedule: any, C_BPartner_ID: number, validTo: string): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_employee_schedule/${C_BPartner_ID}/${validTo}`, employeeSchedule, OPTIONS);
  }

  insertEmployeeAddress(addressDetails: any, C_BPartner_ID: number): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `account/employee_address/create_update/${C_BPartner_ID}`, addressDetails, OPTIONS);
  }

  getEmployeeInfo() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_employee_info`, OPTIONS);
  }

  getEmployeeInfoAll() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_employee_info_all`, OPTIONS);
  }

  deleteEmployee(id: any) {
    return this.http.delete<any>(Library.API_ENDPOINT + `account/delete_employee/${id}`, OPTIONS);
  }

  getEmployeeDetails(C_BPartner_ID: number) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_employee_details/${C_BPartner_ID}`, OPTIONS);
  }

  updateEmployeeDetails(employeeDetails: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/update_employee_details`, employeeDetails, OPTIONS);
  }

  getEmployeeScheduleDetails(C_BPartner_ID: number) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_employee_schedule/${C_BPartner_ID}`, OPTIONS);
  }

  getSchedules() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_schedules`, OPTIONS);
  }

  updateScheduleDetails(schedule: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/update_employee_schedule`, schedule, OPTIONS);
  }

  updateFlexiScheduleDetails(schedule: any) {
    // TODO: replace endpoint once backend is ready
    return this.http.post<any>(Library.API_ENDPOINT + `account/update_employee_flexi_schedule`, schedule, OPTIONS);
  }

  getEmployeeAttribute(C_BPartner_ID: number) {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_employee_attribute/${C_BPartner_ID}`, OPTIONS);
  }

  updateAttributeDetails(attributeDetails: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/update_employee_attribute`, attributeDetails, OPTIONS);
  }

  getLeavesCount() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/leaves_count`, OPTIONS);
  }

  getApprovedLeaveAll() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/approved_leave`, OPTIONS);
  }

  getRejectedLeaveAll() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/rejected_leave`, OPTIONS);
  }

  insertConnectedAccounts(username: string, password: string) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/insert_account`, { username, password }, OPTIONS);
  }

  getConnectedAccounts() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_connected_accounts`, OPTIONS);
  }

  deleteConnectedAccount(username: string) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/delete_connected_account/${username}`, OPTIONS);
  }

  getEMployeeAddress(C_BPartner_ID: number) {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_employee_address/${C_BPartner_ID}`, OPTIONS);
  }

  getPlanInfo(): Observable<any> {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_client_plan`, OPTIONS);
  }

  updateUserInfo(userInfo: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/update_user_info`, userInfo, OPTIONS);
  }

  updateAddressInfo(addressInfo: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/address/create_update`, addressInfo, OPTIONS);
  }

  requestLoan(loanForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/request_loan`, loanForm, OPTIONS);
  }

  getPendingLoan(): Observable<any> {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_pending_loan`, OPTIONS);
  }

  getDeclinedLoan(): Observable<any> {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_declined_loan`, OPTIONS);
  }

  getApprovedLoan(): Observable<any> {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_approved_loan`, OPTIONS);
  }

  approveLoan(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/approve_loan/${id}`, OPTIONS);
  }

  declineLoan(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/decline_loan/${id}`, OPTIONS);
  }

  workdaysRequest(workdaysForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/workdays_requests`, workdaysForm, OPTIONS);
  }

  editWorkdaysRequest(workdaysForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `account/edit_workdays_requests`, workdaysForm, OPTIONS);
  }

  getWorkdaysRequests(): Observable<any> {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_workdays_requests`, OPTIONS);
  }

  getEmployeeWorkdaysRequests(): Observable<any> {
    return this.http.get<any>(Library.API_ENDPOINT + `account/get_employee_workdays_requests`, OPTIONS);
  }

  workdaysRequestApproval(id: number, type: string, reason?: string) {
    let url = `${Library.API_ENDPOINT}account/workdays_requests_approval/${id}/${type}`;

    if (reason) {
      url += `?reason=${encodeURIComponent(reason)}`;
    }

    return this.http.post<any>(url, null, OPTIONS);
  }

  getWorkdaysRequestsCount() {
    return this.http.get<any>(Library.API_ENDPOINT + `account/workdays_requests_count`, OPTIONS);
  }

  importDatMachine(payload: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `import-dat/import_dat_ngteco_machine`, payload, OPTIONS);
  }

  importDatWeb(payload: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `import-dat/import_dat_ngteco_web`, payload, OPTIONS);
  }

  importZKMachine(payload: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `import-dat/import_dat_zkteco_machine`, payload, OPTIONS);
  }

  getPayrollMovement() {
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_payroll_movement`, OPTIONS);
  }

  getEmployeeAttendanceStats() {
    return this.http.get<any[]>(Library.API_ENDPOINT + 'account/get_employee_attendance_stats', OPTIONS);
  }

  getPerEmployeeAttendanceStats(cbpartnerId: number, period: number): Observable<any> {
    return this.http.get(Library.API_ENDPOINT + `account/get_per_employee_attendance_stats/${cbpartnerId}?period=${period}`);
  }

  // New method for range-based queries
  getPerEmployeeAttendanceStatsWithRange(cbpartnerId: number, rangeType: string): Observable<any> {
    return this.http.get(Library.API_ENDPOINT + `account/get_per_employee_attendance_stats/${cbpartnerId}?range=${rangeType}`);
  }

  // New method for custom date range
  getPerEmployeeAttendanceStatsCustomRange(cbpartnerId: number, fromDate: string, toDate: string): Observable<any> {
    // Format dates to YYYY-MM-DD if they're Date objects
    const from = typeof fromDate === 'string' ? fromDate : this.formatDate(fromDate);
    const to = typeof toDate === 'string' ? toDate : this.formatDate(toDate);

    return this.http.get(Library.API_ENDPOINT + `account/get_per_employee_attendance_stats/${cbpartnerId}?from=${from}&to=${to}`);
  }

  getRegisteredSPClients() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_registered_spClients', OPTIONS);
  }

  getClientDetails(month?: number): Observable<any[]> {
    const params = month !== undefined ? `?month=${month + 1}` : ''; // +1 to convert from 0-indexed to 1-indexed
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_client_details${params}`);
  }

  getClientDetailsAll(month?: number): Observable<any[]> {
    const params = month !== undefined ? `?month=${month + 1}` : ''; // +1 to convert from 0-indexed to 1-indexed
    return this.http.get<any[]>(Library.API_ENDPOINT + `account/get_client_details_all${params}`);
  }

  getLeaveReports(filters?: {
    status?: string;
    startDate?: string;
    endDate?: string;
    employeeName?: string;
  }): Observable<LeaveRecord[]> {
    let params = new HttpParams();

    if (filters) {
      if (filters.status) params = params.set('status', filters.status);
      if (filters.startDate) params = params.set('startDate', filters.startDate);
      if (filters.endDate) params = params.set('endDate', filters.endDate);
      if (filters.employeeName) params = params.set('employeeName', filters.employeeName);
    }

    return this.http.get<LeaveRecord[]>(Library.API_ENDPOINT + `account/leave_report`, { params });
  }

  uploadProfilePicture(imageData: string, fileName: string): Observable<any> {
    const payload = {
      imageData: imageData,
      fileName: fileName
    };
    return this.http.post(Library.API_ENDPOINT + `account/upload_profile_picture`, payload);
  }

  removeProfilePicture(): Observable<any> {
    return this.http.delete(Library.API_ENDPOINT + 'account/remove_profile_picture');
  }

  updateLoanLine(loanLineData: any): Observable<any> {
    return this.http.put(Library.API_ENDPOINT + `account/loan-lines/update`, loanLineData);
  }

  // Helper method to format dates
  private formatDate(date: any): string {
    if (!date) return '';

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}
